class Testimonials extends HTMLElement {
  constructor() {
    super();

    this.currentSlide = 0;
    this.slides = this.querySelectorAll(".testimonials__slide");
    this.slideContainer = this.querySelector(".testimonials__slides");

    this.handleScroll = this.handleScroll.bind(this);
    this.updateActiveSlide = this.updateActiveSlide.bind(this);
    this.nextSlide = this.nextSlide.bind(this);
    this.previousSlide = this.previousSlide.bind(this);

    this.slideContainer.addEventListener("scroll", this.handleScroll);

    this.next_button = this.querySelector(".next-button");
    this.previous_button = this.querySelector(".previous-button");

    this.next_button.addEventListener("click", (event) => {
      this.nextSlide();
    });
    this.previous_button.addEventListener("click", (event) => {
      this.previousSlide();
    });

    // add indictator buttons

    this.slides.forEach((slide, index) => {
      const indicator = document.createElement("button");
      indicator.classList.add("testimonials__indicator");
      indicator.setAttribute("data-slide", index);
      indicator.setAttribute("aria-label", `Go to slide ${index + 1}`);
      indicator.innerText = index + 1;
      indicator.classList.add("indicator");

      if (index === 0) {
        indicator.classList.add("active");
      }

      indicator.addEventListener("click", () => {
        this.currentSlide = index;
        this.scrollToActiveSlide();
      });
      this.querySelector(".testimonials__indicators").appendChild(indicator);
    });

    this.indicators = this.querySelectorAll(".testimonials__indicator");

    console.log(this.indicators);

    this.updateActiveSlide(0);
    this.handleScroll();
  }

  handleScroll() {
    const scrollProgress =
      this.slideContainer.scrollLeft /
      (this.slideContainer.scrollWidth - this.slideContainer.clientWidth);

    this.activeSlide = Math.round(scrollProgress * (this.slides.length - 1));

    // slide in center of screen

    this.slides.forEach((slide, index) => {
      const slideBounds = slide.getBoundingClientRect();
      const slideCenter = slideBounds.left + slideBounds.width / 2;
      const containerCenter = this.slideContainer.clientWidth / 2;

      slide.classList.remove("visible");

      if (Math.abs(containerCenter - slideCenter) < 100) {
        slide.classList.add("visible");
      }
    });

    if (this.activeSlide !== this.currentSlide) {
      this.updateActiveSlide(this.activeSlide);
    }
  }

  updateActiveSlide(num) {
    this.slides.forEach((slide, index) => {
      if (index === num) {
        slide.classList.add("active");
        this.indicators[index].classList.add("active");
      } else {
        slide.classList.remove("active");
        this.indicators[index].classList.remove("active");
      }
    });

    this.currentSlide = num;
  }

  scrollToActiveSlide() {
    //console.log("Scolling to active slide", this.currentSlide);
    this.slideContainer.scroll({
      left: this.slideContainer.clientWidth * this.currentSlide,
      behavior: "smooth",
    });
  }

  nextSlide() {
    this.currentSlide++;
    this.scrollToActiveSlide();
  }
  previousSlide() {
    this.currentSlide--;
    this.scrollToActiveSlide();
  }
}

customElements.define("testimonals-slides", Testimonials);
